import React from 'react';
import EmbededPowerBi from '../../components/EmbededPowerBI';
import { POWERBI_IDS } from '../../utils/Constant';

const TopPerformersPage: React.FunctionComponent = () => {
  return (
    <div className="dashboard-parent">
      <div className="topPerformer">
        <EmbededPowerBi
          groupId={POWERBI_IDS.groupId}
          reportId={POWERBI_IDS.topPerformersId}
        />
      </div>
    </div>
  );
};

export default TopPerformersPage;
